import { HeaderSlotComponent, HeaderSlotRegistry } from "@/types/header.types";
import { HEADER_SLOT } from "@/constants/Route.constant";
import {
  BrowseViewSwitchSlot,
  ProjectActionsSlot,
  WaypointActionsSlot
} from "./HeaderSlotRegistry";

type HeaderSlotKey = (typeof HEADER_SLOT)[keyof typeof HEADER_SLOT];

const rightHeaderSlotRegistry: HeaderSlotRegistry = {
  [HEADER_SLOT.BROWSE_VIEW_SWITCH]: BrowseViewSwitchSlot
};

const leftHeaderSlotRegistry: HeaderSlotRegistry = {
  [HEADER_SLOT.PROJECT_ACTIONS]: ProjectActionsSlot,
  [HEADER_SLOT.WAYPOINT_ACTIONS]: WaypointActionsSlot
};

export const getRightHeaderSlot = (
  slotKey: string
): HeaderSlotComponent | undefined => {
  return rightHeaderSlotRegistry[slotKey as HeaderSlotKey];
};

export const getLeftHeaderSlot = (
  slotKey: string
): HeaderSlotComponent | undefined => {
  return leftHeaderSlotRegistry[slotKey as HeaderSlotKey];
};
